import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0030',
    ecrans: ['00-2'],
    params: ['id', '?prucleint', '?cifcleint', '?unacleint', '?pecann', '?vaesysnatctb', '?tymcleint']
});
